module.exports = __webpack_public_path__ + "static/media/shield_pulsoximeter-green.bc8bd6e6.svg";